import { useEffect, useState } from 'react';
import axios from 'axios';

const TEAM_API_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8081/safetywing-frontend/team'
    : '/safetywing-frontend/team';

const useFetchTeam = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [team, setTeam] = useState([]);
  const [error, setError] = useState(null);

  const sortRecords = (records) => {
    return records
      .map((record) => ({ id: record?.id, ...record?.fields }))
      .sort((x, y) => {
        if (x?.categories?.[0] === 'Founders') return -1;
        if (y?.categories?.[0] === 'Founders') return 1;
        return 0;
      });
  };

  useEffect(() => {
    const fetchTeam = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(TEAM_API_URL);
        setTeam(sortRecords(response.data.records));
        setIsLoading(false);
      } catch (error) {
        setError(error);
      }
    };

    fetchTeam();
  }, []);

  return { isLoading, team, error };
};

export default useFetchTeam;
